import React, { FormEvent, useState } from 'react';
import './PrivateBetaGate.css';

const ACCESS_KEY = 'pawerlifting-private-beta-access';
const PASSWORD_HASH = '747f09e9e583fe512fd37214f191e3467c64699f02e2a0cb18e098c48cb0ccaa';

const hashPassword = async (password: string): Promise<string> => {
  const bytes = new TextEncoder().encode(password);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
};

const PrivateBetaGate: React.FC = ({ children }) => {
  const [hasAccess, setHasAccess] = useState(() => sessionStorage.getItem(ACCESS_KEY) === 'granted');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(false);

  const unlock = async (event: FormEvent) => {
    event.preventDefault();
    setChecking(true);
    setError('');

    try {
      if (await hashPassword(password) === PASSWORD_HASH) {
        sessionStorage.setItem(ACCESS_KEY, 'granted');
        setHasAccess(true);
        return;
      }

      setError('That password does not look right. Please try again.');
      setPassword('');
    } finally {
      setChecking(false);
    }
  };

  return (
    <>
    {children}
    {!hasAccess && <main className="private-beta-gate">
      <section className="private-beta-card" aria-labelledby="private-beta-title">
        <div className="private-beta-copy">
          <span className="private-beta-eyebrow">Private beta</span>
          <h1 id="private-beta-title">Ploppy is getting things ready.</h1>
          <p>PawerLifting is currently open to invited testers only.</p>

          <form onSubmit={unlock} className="private-beta-form">
            <label htmlFor="private-beta-password">Access password</label>
            <div className="private-beta-input-row">
              <input
                id="private-beta-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={event => setPassword(event.target.value)}
                placeholder="Enter password"
                autoFocus
              />
              <button type="submit" disabled={!password || checking}>
                {checking ? 'Checking…' : 'Enter'}
              </button>
            </div>
            {error && <p className="private-beta-error" role="alert">{error}</p>}
          </form>
        </div>

        <div className="private-beta-ploppy" aria-hidden="true">
          <span className="private-beta-halo" />
          <img src="/assets/ploppy/ploppy.png" alt="" />
        </div>
      </section>
    </main>}
    </>
  );
};

export default PrivateBetaGate;
